/**
 * storeEnv.js — detecção do ambiente "app instalado" Android (TWA/PWA).
 *
 * Usado para conformidade com a política de pagamentos do Google Play
 * (modelo Netflix/Spotify): dentro do app Android NÃO oferecemos fluxo de
 * compra/assinatura — o botão informa que a gestão é feita na versão web,
 * SEM link clicável (link direto para compra externa viola a política).
 *
 * - TWA (app da Play Store): document.referrer começa com android-app://
 * - PWA instalado: display-mode standalone
 * iOS não é afetado (distribuição via PWA, fora da App Store).
 */
export function isAndroidInstalledApp() {
  try {
    const ua = navigator.userAgent || '';
    if (!/Android/i.test(ua)) return false;
    const standalone = window.matchMedia?.('(display-mode: standalone)')?.matches;
    const fromTwa = (document.referrer || '').startsWith('android-app://');
    return Boolean(standalone || fromTwa);
  } catch {
    return false;
  }
}

export const STORE_BILLING_MESSAGE =
  'Para contratar ou gerenciar sua assinatura, acesse a versão web do IAT ' +
  'pelo navegador do computador. Aqui no aplicativo você acompanha o plano, ' +
  'mas a contratação é feita na versão web.';
